import useAxios from '@/utilities/useAxios'

interface ApiResponse {
  httpStatus: string
  success: boolean
  message: string
  data: string
  errors: any
  errorCode: number
  timestamp: number
  path: string | null
  totalElements: number | null
  size: number
}

interface UserResponse {
  httpStatus: string
  success: boolean
  message: string
  data: {
    id: number
    firstName: string
    lastName: string
    email: string
    sourceUserId: string
    dateCreated: string
    dateModified: string
    userRoles: Array<{
      id: number
      dateCreated: string
    }>
    userAreas: any[]
  }
  errors: any
  errorCode: number
  timestamp: number
  path: string | null
  totalElements: number | null
  size: number
}

export const fetchUserCode = async (userId: string): Promise<string> => {
  const BACKEND_URL = `${import.meta.env.VITE_DND_APP_BACKEND_URL}`

  try {
    const userResponse = await useAxios.get<UserResponse>(
      `${BACKEND_URL}/v1/user/${userId}`,
    )

    if (!userResponse.data.success || !userResponse.data.data?.id) {
      throw new Error(
        `Failed to get user id for userId ${userId}: ${userResponse.data.message}`,
      )
    }

    const internalId = userResponse.data.data.id

    const encryptResponse = await useAxios.get<ApiResponse>(
      `${BACKEND_URL}/v1/authentication/encrypt/${internalId}?sourceUserId=${userId}`,
    )

    if (encryptResponse.data.success && encryptResponse.data.data) {
      return encryptResponse.data.data
    } else {
      throw new Error(
        `Failed to fetch code for user ${userId}: ${encryptResponse.data.message}`,
      )
    }
  } catch (error) {
    console.error(`Error fetching code for user ${userId}:`, error)
    throw error
  }
}
